<template lang="pug">
v-row(
  align="start"
  :class=`{
    'flex-column': isColumn,
  }`
).pb-5
  v-col(v-bind="columns.img")
    template(v-if="loading")
      v-skeleton-loader(
        type="image"
      ).loader
    template(v-else)
      v-img(
        :src="image"
        contain
        @click="reloadCaptcha"
      ).captcha-img
  v-col(v-bind="columns.field")
    app-text-input(
      v-model="captchaInput"
      v-bind="attrs"
      v-on="listeners"
    )
</template>

<script>
export default {
  name: 'CaptchaField',
  props: {
    value: {
      type: Object,
      default: () => ({ key: null, value: null }),
    },
    isColumn: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: false,
    image: null,
    key: null,
    captchaInput: null,
  }),
  computed: {
    attrs() {
      const { value, ...rest } = this.$attrs;

      return {
        label: 'Введите символы с картинки',
        ...rest,
      };
    },
    listeners() {
      const { input, ...rest } = this.$listeners;

      return {
        ...rest,
        input: this.onInput,
      };
    },
    columns() {
      if (this.isColumn) {
        return {};
      }

      return {
        field: {
          sm: 7,
          cols: 6,
        },
        img: {
          sm: 5,
          cols: 6,
        },
      };
    },
  },
  created() {
    this.init();
  },
  methods: {
    onInput(value) {
      this.$emit('input', { key: this.key, value });
    },
    init() {
      this.loadCaptcha();
      this.$emit('initialized', this);
    },
    reloadCaptcha() {
      this.captchaInput = null;
      this.loadCaptcha();
    },
    async loadCaptcha() {
      this.loading = true;

      const { response, error } = await this.$rApi.auth.getCaptcha();
      if (error) {
        this.loading = false;
        return;
      }

      const { image_data, key } = response.data.data;
      this.image = image_data;
      this.key = key;
      this.$emit('update:data', this.key);

      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.loader {
  height: 60px;
  border-radius: 10px;
}

.captcha-img {
  border-radius: 4px;
  background-color: white;
  height: 60px;
  cursor: pointer;
}
</style>
